<div class="sidenav bg-theme animate__animated animate__fadeInLeft">
  <div class="login-main-text" style="text-align: center; margin-top: 34%;">
    <!-- <h2>
      eDiary<br />
      Login Page
    </h2> -->
    <div >
      <img style="height: 50px;
      width: 180px;" src="../../assets/img/elevate-logo.png" alt="">
    </div>
    <!-- <p>Login from here to access.</p> -->
    <div class="pt-3" ><h5>Transform your Assurance Practice</h5></div>
  </div>
</div>
<div class="main animate__animated animate__fadeInLeft animate__delay-1s">
  <div class="col-sm-12 col-md-6">
    <div class="login-form">
      <!-- <h5 style="text-align: center;">Sign In</h5> -->
      <form #userForm="ngForm" novalidate>
        <!-- {{userForm | json}} -->
        <!-- {{user | json}} -->
        <div class="form-group">
          <div class="row ml-1">
            <img src="../../assets/img/PGB-Logo-2.jpg" alt="" style="height: 130px; width: 350px;">
          </div>
          <label for="email">Username:</label>
          <input
            type="email"
            class="form-control"
            id="username"
            name="username"
            placeholder=""
            #email="ngModel"
            [(ngModel)]="user.email"
            required
            email
            [class.is-invalid]="email.invalid && email.touched"
          />
          <div *ngIf="email.errors && email.invalid && email.touched">
            <!-- {{email.errors | json}} -->
            <small class="text-danger" *ngIf="email?.errors.required"
              >username is required</small
            >
            <small class="text-danger" *ngIf="email?.errors.email"
              >invalid email</small
            >
          </div>
        </div>
        <div class="form-group">
          <label for="password">Password:</label>
          <input
            type="password"
            class="form-control"
            id="password"
            name="password"
            placeholder=""
            #password="ngModel"
            [(ngModel)]="user.password"
            required
            [class.is-invalid]="password.invalid && password.touched"
          />
          <small
            class="text-danger"
            [class.d-none]="password.valid || password.untouched"
            >password is required</small
          >

          <div class="form-group">
            <div class="float-right">
              <span
                (click)="onModalClick(modalContent)"
                style="cursor: pointer; color:#800000; text-decoration: underline"
              >
                Forgot Password</span
              >
            </div>
          </div>
        </div>

        <button
          type="submit"
          id="loginBtn"
          name="loginBtn"
          mat-raised-button
          class="btn-theme"
          (click)="onLoginClick(userForm)"
        >
          Login
        </button>
      </form>
    </div>
  </div>
</div>

<ng-template #modalContent>
  <div class="modal-header bg-theme bg-theme-txt">
    <h3 class="modal-title mt-3 mb-3 ml-3" id="modal-basic-title ">
      Forgot Password
    </h3>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
       <span aria-hidden="true">&times;</span>
     </button> -->
  </div>
  <div class="modal-body">
    <form [formGroup]="forgotPasswordForm">
      <div class="mt-4 ml-5 mb-5">
        <label class="col-sm-4">Email :</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" formControlName="email" />
          <div
            *ngIf="submitted && forgotPasswordForm.controls['email'].invalid"
          >
            <div *ngIf="forgotPasswordForm.controls['email'].errors.required">
              <span style="color: red">Email is required.</span>
            </div>
            <div *ngIf="forgotPasswordForm.controls['email'].errors.pattern">
              <span style="color: red"
                >Please enter a valid email address.</span
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>

      <div class="col-sm-3">
        <button
          id="saveBtn"
          name="saveBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onSaveClick()"
        >
          Save
        </button>
      </div>

      <div class="col-sm-3">
        <button
          id="closeBtn"
          name="closeBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          ngbAutofocus
          (click)="closeModel()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
